import { useCompanyConfiguration } from 'init/use-company-configuration';

export function useUseMatching() {
  const company = useCompanyConfiguration();
  return company.tp_accounting.use_payment_matching;
}
